import { Fragment } from "react";
import {
  IconButton,
  Icon,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";

const Dialogs = (props) => {
  return (
    <Fragment>
      <Dialog aria-labelledby="job-confirm-title" open={props.dialogAppExitOpen}>
        <DialogTitle id="job-confirm-dialog">
          <Icon>warning</Icon> Exit App
        </DialogTitle>
        <DialogContent>Are you sure you want to exit the app?</DialogContent>
        <DialogActions>
          <IconButton
            id="cancel_exit_button"
            onClick={() => props.setDialogAppExitOpen(false)}
            autoFocus
          >
            <Icon color="primary">clear</Icon>
          </IconButton>
          <IconButton
            id="confirm_exit_button"
            onClick={() => props.handleSignOut()}
          >
            <Icon color="secondary">check</Icon>
          </IconButton>
        </DialogActions>
      </Dialog>
      <Dialog aria-labelledby="job-confirm-title" open={props.dialogReloadOpen}>
        <DialogTitle id="job-confirm-dialog">
          <Icon>warning</Icon> Reload
        </DialogTitle>
        <DialogContent>Are you sure you want to reload the list?</DialogContent>
        <DialogActions>
          <IconButton onClick={() => props.setDialogReloadOpen(false)} autoFocus>
            <Icon color="primary">clear</Icon>
          </IconButton>
          <IconButton onClick={() => window.location.reload()}>
            <Icon color="secondary">check</Icon>
          </IconButton>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};
export default Dialogs;
